import { IconButton } from "@mui/material"
import EditableText from "components/controls/input-hidden"
import ArrowBackIcon from "components/icons/base/back"
import SaveIcon from "components/icons/editor/save"
import { action } from "mobx"
import { observer } from "mobx-react-lite"
import { useContentEditorStore } from "pages/content/store"
import { Header } from "pages/content/styled"
import { useEffect } from "react"
import { useMainStore } from "store"
import useKeyDown from "utils/use-key-down"
import { useLocation } from "wouter"
import Tooltip from "../tooltip"

type Props = {
  id?: string
}

const ContentPageHeader = observer(({ id }: Props) => {

  const mainStore = useMainStore()
  const contentStore = useContentEditorStore()
  const [ , setLocation ] = useLocation()

  const projectId = (id || "").slice(0, 4)
  const contentId = (id || "").slice(5)

  const project = mainStore.projects.get(projectId)
  const content = project && project.contents.get(contentId)
  const schema = content && mainStore.schemes.get(content.schemeId)

  useEffect(() => {
    const project = mainStore.projects.get(projectId)
    const content = project && project.contents.get(contentId)
    const schema = content && mainStore.schemes.get(content.schemeId)

    if (!content || !schema) return
    contentStore.load(content, schema.data)
    if (project && content) {
      let prefix = 'landings.v2'
      if (content.data.slugPrefix) {
        prefix = content.data.slugPrefix
        if (prefix === "-") prefix = ""
      }
      let key = [ prefix, project.slug, schema.data.slug, content.data.sectionId, 'section' ]
      if (schema.data.slugSchema) {
        key = []
        for (let item of schema.data.slugSchema.split(".")) {
          let value = item.trim()
          if (value === "{prefix}") { 
            key.push(prefix)
          } else if (value === "{site}") { 
            key.push(project.slug)
          } else if (value === "{slug}") { 
            key.push(schema.data.slug)
          } else if (value === "{sectionId}") { 
            key.push(content.data.sectionId)
          } else {
            key.push(item)
          }
        }
      }
      // if (schema.data.slugPosition === "afterSchemaSlug") {
      //   key = [ prefix, schema.data.slug, content.data.sectionId, project.slug ]
      // }

      contentStore.setBaseKey(key.filter(i => !!i).join('.'))
    }
  }, [ id ])  // eslint-disable-line react-hooks/exhaustive-deps

  useKeyDown({
    "KeyS": (e) => { if (e.ctrlKey) {
        save()
        e.preventDefault()
    }}
  })

  const save = () => {
    if (content) {
      const obj = contentStore.save()
      console.log(obj)
      content.data.values = obj
      mainStore.saveContent(content)
    }
  }

  const toBack = () => {
    setLocation("/")
  }

  return (
    <Header sx={{ mb: 2 }}>
      <IconButton onClick={toBack} sx={{ ml: -1.4, mr: 1 }}>
        <ArrowBackIcon sx={{ fontSize: 20 }}/>
      </IconButton>
      <EditableText 
        value={ content?.name || "" }
        onChange={action(e => content!.name = e.target.value)}
        sx={{ fontSize: 20, fontWeight: 700 }} 
        placeholder="Название блока"
      />
      { !contentStore.isSaved && (
        <IconButton onClick={save} sx={{ ml: 1.5, color: "primary.main", bgcolor: "#263041" }}>
          <SaveIcon sx={{ fontSize: 20 }}/>
        </IconButton>
      )}
      { schema?.data.description && (
        <Tooltip 
          title={schema.data.description} 
          placement="bottom-end"
          sx={{ ml: "auto", mt: 1, mr: 1, "svg": { fontSize: 20 } }}
          PopperProps={{ sx: { ".MuiTooltip-tooltip": { maxWidth: 500, whiteSpace: "pre-wrap" } }}}
        />
      )}
    </Header>
  )
})

export default ContentPageHeader